<template lang="pug">
  .b2b-table-auditoria-acciones
    //- Filtros Tabla Auditorias
    b2b-filters-auditoria-acciones(:filter-options='options' @updateAuditActions="refreshAuditActions")

    ods-table(
      :data='auditActions.tableData',
      :default-sort="{prop: 'creationDateTime', order: 'descending'}",
      style='width: 100%',
      @sort-change='orderOnServer',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='mini',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='project',
        :label='$t("auditory.auditory_entity_table.project")',
        :show-overflow-tooltip='true',
        v-if='isShowServicioAuditoriaAct',
        sortable='')
      ods-table-column(
        prop='user',
        :label='$t("auditory.auditory_entity_table.user")',
        :show-overflow-tooltip='true',
        v-if='isShowUserAuditoriaAct',
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("auditory.auditory_entity_table.date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateAuditoriaAct',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='action',
        :label='$t("auditory.auditory_entity_table.action")',
        :show-overflow-tooltip='true',
        v-if='isShowActionAuditoriaAct',
        :formatter='formatterAuditoryAction',
        sortable='')
      ods-table-column(
        prop='functionalGroup',
        :label='$t("auditory.auditory_entity_table.group")',
        :show-overflow-tooltip='true',
        v-if='isShowGroupAuditoriaAct',
        :formatter='formatterAuditoryGroup',
        sortable='')
      ods-table-column(
        prop='value',
        :label='$t("auditory.auditory_entity_table.value")',
        :show-overflow-tooltip='true',
        v-if='isShowValueAuditoriaAct',
        width='450%'
        sortable='')
      ods-table-column(
        label,
        align='center',
        :render-header='renderHeaderActions',
        width='90')

    //- Paginación Tabla
    ods-row.b2b-table-auditoria-acciones__pagination(v-if='auditActions.totalAuditActions > 0')
      ods-col.b2b-table-auditoria-acciones__pagination--right(:span='24')
        div.block(style='margin-bottom: 50px;')
          ods-pagination(
            ref='pagination',
            popper-class='b2b-pagination__dropdown',
            @size-change='handleSizeChange',
            @current-change='handleCurrentChangePagination',
            :current-page.sync='currentPage',
            :page-sizes='[20, 50, 100]',
            :page-size='20',
            layout='total, sizes, prev, pager, next, slot',
            :total='auditActions.totalAuditActions')

    //- Auditorias Seleccionadas
    transition(
      name='slide',
      mode='out-in')
        b2b-table-select-rows(
          v-if='multipleSelection.length',
          :total-select='multipleSelection.length')

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bFiltersAuditoriaAcciones from '@/views/auditorias/acciones/B2bFiltersAuditoriaAcciones'
import B2bTableMenuAuditoriaAcciones from './B2bTableMenuAuditoriaAcciones'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-auditoria-acciones'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-auditoria-acciones',
  mixins: [Utils],
  data () {
    return {
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      downloadSelectionIds: [],
      // Paginación
      totalResults: 0,
      currentPage: 0
    }
  },

  computed: {
    ...mapGetters([
      'auditActions',
      'queryAuditActions',
      'isShowServicioAuditoriaAct',
      'isShowUserAuditoriaAct',
      'isShowDateAuditoriaAct',
      'isShowActionAuditoriaAct',
      'isShowGroupAuditoriaAct',
      'isShowValueAuditoriaAct',
      'optionsFilterService'
    ])
  },

  components: {
    B2bFiltersAuditoriaAcciones,
    B2bTableMenuAuditoriaAcciones,
    B2bTableSelectRows
  },

  methods: {
    refreshAuditActions () {
      this.loading = true
      this.cleanData()
      this.$forceUpdate()
      setTimeout(() => this.loading = false, 2000) // eslint-disable-line
    },
    ...mapActions([
      'getAuditActions',
      'queryAuditActionsState',
      'getOptionsService',
      'optionsServicesEnabledState'
    ]),

    // Formatear acción de la auditoria
    formatterAuditoryAction (row, column) {
      if (row[column.property]) {
        const code = row[column.property]
        return this.$t('auditaction.' + code)
      } else return ''
    },

    // Formatear grupo funcional de la auditoria
    formatterAuditoryGroup (row, column) {
      if (row[column.property]) {
        const code = row[column.property]
        return this.$t('functionalGroup.' + code)
      } else return ''
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      let stringSort = ''
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      if (order === 'descending') {
        order = 'DESC'
      } else if (order === 'ascending') {
        order = 'ASC'
      } else {
        order = 'ASC'
      }

      if (!prop) {
        prop = 'creationDateTime'
      }

      stringSort = prop + ',' + order
      this.queryAuditActions.sort = stringSort
      try {
        const dataQueryService = { page: 0, size: 1000, sort: 'name,ASC' }
        this.optionsService = await this.getOptionsService(dataQueryService)
        await this.optionsServicesEnabledState(this.optionsService)
        if (this.optionsFilterService.length == 1) { // eslint-disable-line
          this.queryAuditActions.idProject = this.optionsFilterService[0].id
        }

        await this.queryAuditActionsState(this.queryAuditActions)
        dataQuery.query = this.queryAuditActions
        const response = await this.getAuditActions(dataQuery)
        this.totalResults = response.data.totalElements
        this.currentPage = response.data.number + 1
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuAuditoriaAcciones />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryAuditActions.size = val
        await this.queryAuditActionsState(this.queryAuditActions)
        dataQuery.query = this.queryAuditActions
        const response = await this.getAuditActions(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryAuditActions.page = val - 1
        await this.queryAuditActionsState(this.queryAuditActions)
        dataQuery.query = this.queryAuditActions
        const response = await this.getAuditActions(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      this.options = filters.filters
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-auditoria-acciones {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .block {
        float: right;
      }
      .ods-pagination {
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}

</style>
